import React, { useState, useEffect } from "react";
import "../LoanAgreement/LoanAgreement.css";
import { Grid } from "@mui/material";
import Proptypes from "prop-types";
import { BaseUrl, ImageBaseUrl } from "../../Environment";
import moment from "moment";
import { getSecureItem } from "../../utilsFunctions";
import Axios from "axios";

export const LoanReport = ({ data, printRef, noOfLoans }) => {
  const loggedinUser = getSecureItem("loggedinUser");
  const currency = getSecureItem("country")?.symbol;
  const userType = loggedinUser?.userType;

  const [cAgentData, setCAgentData] = useState([]);

  const companyData = data?.company;
  const customerData = data?.customer;
  const customerDataAddresses = data?.customer?.addresses[0];
  const customerDataLoanType = data?.loanType;
  const loanCollections = data?.loanCollections;
  const firstLoanCollection = data?.loanCollections[0];
  const summary = data?.summary || {};

  const {
    loanTenureType,
    // loanTenure,
    // collectionAmount,
    loanAmount,
    loanId,
    method,
    // processFee,
    totalAmountToCollect,
    collectorId,
  } = data;

  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  const customerAddress = (address) =>
    [address?.AddressStreet, address?.AddressLandmark]
      .filter(Boolean)
      .join(", ");

  const customerAddress2 = (address) =>
    [address?.AddressCity, address?.AddressState, address?.AddressPincode]
      .filter(Boolean)
      .join(", ");

  const getAllUsers = async () => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(`${BaseUrl}/user/getAllUsers?userName=&companyId=${companyId}`, {
      headers,
    })
      .then((res) => {
        const Response = res.data?.result;
        const filteredArr = userType === "Collection Agent" ? Response?.filter((item) => item?.userId == loggedinUser?.userId) : Response;

        setCAgentData(
          filteredArr.map((ca) => ({
            label: `${ca.firstName} ${ca.lastName}`,
            value: ca.userId,
          }))
        );
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <div ref={printRef} className="loan-agreement">
      <Grid container>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black" }}
        >
          <div className="header-left">
            {companyData?.profilePic ? (
              <img
                src={
                  getSecureItem("loggedinUserCompany") == "1365"
                    ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
                    : `${ImageBaseUrl}${companyData?.profilePic}`
                }
                alt="Logo"
                className="logo"
              />
            ) : (
              <div
                style={{
                  height: "120px",
                }}
              ></div>
            )}
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          paddingX={2}
          style={{ border: "1px solid black", borderRightWidth: "0px" }}
        >
          <div className="header-right">
            <h1>{companyData?.companyName}</h1>
            <p>
              <strong>Address: </strong> {getAddress(companyData)}
              <br />
              <strong>GSTIN: </strong> {companyData?.GstIn || ""} |{" "}
              <strong>CIN: </strong> {companyData?.CIN || ""} |{" "}
              <strong>Website: </strong> {companyData?.companyWebsite || ""}
              <br />
              <strong>Mobile No: </strong> {companyData?.phone}{" "}
              <strong>| Email ID: </strong> {companyData?.companyMail}
            </p>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black", borderLeftWidth: "0px" }}
        />
      </Grid>
      <h2 className="title">
        Account Statement -{" "}
        {customerData?.firstName +
          " " +
          customerData?.lastName +
          ` (${customerData?.cust_id})`}
      </h2>
      <div style={{marginBottom: 10}} align="right">
        <span className="Fonts">All amounts are in {currency}.</span>
      </div>
      <div className="content">
        <div className="section">
          <table className="info-table">
            <tbody>
              <tr>
                <td colspan={3}>
                  <h3 style={{ fontSize: 20 }}>Personal Details</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Customer Name</strong> <br />
                  {customerData?.firstName + ` (${customerData?.cust_id})`}
                </td>
                <td>
                  <strong>Address</strong> <br />
                  {customerAddress(customerDataAddresses)}
                </td>
                <td>
                  <strong>District/State</strong> <br />
                  {customerAddress2(customerDataAddresses)}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Contact No</strong> <br /> {customerData?.phone}
                </td>
                <td>
                  <strong>Gender : </strong> {customerData?.gender}
                  <br /> <strong>DOB : </strong>
                  {customerData?.dob && moment(customerData?.dob).format("DD-MM-YYYY")}
                </td>
                <td>
                  <strong>C/O</strong> <br /> {customerData?.fatherName}
                </td>
              </tr>
              <tr>
                <td colspan={3}>
                  <h3 style={{ fontSize: 20 }}>Loan Details</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Loan ID</strong> <br />
                  {loanId}
                </td>
                <td>
                  <strong>Loan Type</strong> <br />
                  {customerDataLoanType?.loanType}
                </td>
                <td>
                  <strong>Loan Amount Sanctioned</strong> <br />
                  {currency} {loanAmount}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Duration</strong> <br />
                  {moment(firstLoanCollection?.dueDate).format("DD MMM YYYY") +
                    " - " +
                    moment(
                      loanCollections[loanCollections?.length - 1]?.dueDate
                    ).format("DD MMM YYYY")}
                </td>
                <td>
                  <strong>Collection Frequency</strong> <br />
                  {loanTenureType}
                </td>
                <td>
                  <strong>No. of Payments</strong> <br />
                  {loanCollections?.length}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Loan Status</strong> <br />
                  {data?.loanStatus}
                </td>
                <td>
                  <strong>Processing Fee</strong> <br />
                  {data?.processFee}
                </td>
                <td>
                  <strong>Additional Fee</strong> <br />
                  {data?.feeDetailsJson &&
                    Object.entries(data?.feeDetailsJson)
                      .filter(([key]) => key !== "totalFee")
                      .map(([key, value]) => (
                        <div key={key}>
                          {key}: {currency} {value}
                        </div>
                      ))}
                </td>
              </tr>
              <tr>
                <td colspan={3}>
                  <h3 style={{ fontSize: 20 }}>Repayment Status</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Total Repayable Amount</strong> <br />
                  {currency} {totalAmountToCollect}
                </td>
                <td>
                  <strong>Amount Paid</strong> <br />
                  {currency} {summary.totalAmountPaid}
                </td>
                <td>
                  <strong>Outstanding Balance</strong> <br />
                  {currency} {summary.balanceAmount}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Penalty Applied</strong> <br />
                  {currency} {summary.penaltyApplied}
                </td>
                <td>
                  <strong>Penalty Applied</strong> <br />
                  {currency} {summary.penaltyApplied}
                </td>
                <td>
                  <strong>Remaining Payments</strong> <br />
                  {summary.remainingPayments}
                </td>
                {/* <td>
                  <strong>Collection Agent</strong> <br />
                  {
                    cAgentData?.filter((val) => val.value == collectorId)[0]
                      ?.label
                  }
                </td> */}
              </tr>
              <tr>
                <td colspan={3}>
                  <h3 style={{ fontSize: 20 }}>Upcoming Installment</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Next Payment</strong> <br />
                  {summary.nextPayment?.dueDate
                    ? moment(summary.nextPayment.dueDate).format("LL")
                    : "-"}
                </td>
                <td>
                  <strong>Next Payment Amount</strong> <br />
                  {currency} {summary.nextPayment?.collectionAmount ?? "-"}
                </td>
                <td>
                  <strong>Last Paid</strong> <br />
                  {summary.lastPaid ? (
                    <>
                      Last Paid: {currency}{" "}
                      {summary.lastPaid.collectionAmount} on{" "}
                      {moment(summary.lastPaid.collectedDate).format("LL")}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* New page break */}
        {/* <div className="page-break"></div> */}

        <div className="section">
          <h2 className="title">Repayment Schedule Terms</h2>

          <table className="info-table compact-table">
            <thead>
              <th>Sr. No</th>
              <th>Due Date</th>
              <th>Opening Balance</th>
              {method == "Collection method" ? (
                <th>Installment</th>
              ) : (
                <th>Principal</th>
              )}
              {method == "Collection method" ? (
                <>
                  <th>Collected Amount</th>
                  <th>Penalty</th>
                </>
              ) : (
                <>
                  <th>Interest</th>
                  <th>Collected Amount</th>
                </>
              )}
              <th>Closing Balance</th>
              <th>Collected Date</th>
              <th>Collection Agent</th>
            </thead>
            <tbody>
              {loanCollections?.map((data, i) => {
                const totalRows = loanCollections.length;
                const maxPageBreaks = Math.floor(totalRows / noOfLoans); // Calculate the maximum number of page breaks
                return (
                  <React.Fragment key={data?.srNo}>
                    <tr>
                      <td style={{ width: "5%" }}>{i + 1}</td>
                      <td style={{ width: "15%" }}>
                        {moment(data?.dueDate).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ width: "10%" }}>{data?.openingBalance}</td>
                      {method == "Collection method" ? (
                        <td style={{ width: "10%" }}>{data?.Installment}</td>
                      ) : (
                        <td style={{ width: "10%" }}>{data?.principal}</td>
                      )}
                      {method == "Collection method" ? (
                        <>
                          <td style={{ width: "10%" }}>
                            {data?.collectedDate && data?.collectionAmount}
                          </td>
                          <td style={{ width: "10%" }}>
                            {data?.PenaltyApplied > 0 ? Number(data.PenaltyApplied) : null}
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ width: "10%" }}>{data?.interest}</td>
                          <td style={{ width: "10%" }}>
                            {data?.collectedDate && data?.collectionAmount}
                          </td>
                        </>
                      )}
                      <td style={{ width: "10%" }}>{data?.closingBalance}</td>
                      <td style={{ width: "15%" }}>
                        {data?.collectedDate &&
                          moment(data?.collectedDate).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ width: "15%" }}>
                        {data?.collectedDate &&
                          cAgentData?.filter(
                            (val) => val.value == data?.collectorId
                          )[0]?.label}
                      </td>
                    </tr>
                    {(i + 1) % noOfLoans === 0 &&
                      (i + 1) / noOfLoans <= maxPageBreaks &&
                      i + 1 < totalRows && <tr className="page-break"></tr>}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

LoanReport.prototype = {
  data: Proptypes.any,
  printRef: Proptypes.any,
};
